$(($) => {
	const duration = 400;
	const jobsSection = $(
		'.bs-section--careers-micro-current-openings-job-list'
	);
	const buttonWrapper = jobsSection.find(
		'.bs-div--careers-jobs-filter-wrapper .bs-pro-button'
	);
	let dropdownDiv = jobsSection.find(
		'.bs-div--careers-jobs-filter-container'
	);

	const slideUp = () => {
		dropdownDiv.slideUp(duration);
		buttonWrapper.removeClass('opened');
	}

	const slideUpOnCLickBody = (e) => {
		if (!dropdownDiv.is(e.target) && dropdownDiv.has(e.target).length === 0){
			slideUp();
			return;
		}
		$('body').one('click', (e) => slideUpOnCLickBody(e));
	}

	const slideDown = () => {
		dropdownDiv.slideDown(duration);
		buttonWrapper.addClass('opened');
		$('body').one('click', (e) => slideUpOnCLickBody(e));
	}

	buttonWrapper.on('click', (e) => {
		e.stopPropagation();
		if(buttonWrapper.hasClass('opened')) {
			slideUp();
		} else {
			slideDown();
		}
	});

	// $(document).on('facetwp-loaded', slideUp);

});
